import React, { useCallback } from 'react'
import PackingSlip from '../packingSlip/PackingSlip'
import { RmaDetailLRPrintSlip } from './style/Button.css'

const ConfirmationButton = ({
  orderDetails,
  returnId,
}) => {
  const printClick = useCallback(() => {
    const content = document.getElementById('PackingSlip').innerHTML
    const mywindow = window.open('', 'Print', 'height=700,width=612')

    mywindow.document.write('<html><head><title>Packing Slip</title>')
    mywindow.document.write('</head><body>')
    mywindow.document.write(content)
    mywindow.document.write('</body></html>')

    mywindow.document.close()
    mywindow.focus()
    setTimeout(() => {
      mywindow.print()
      mywindow.close()
    }, 2000)
  }, [])

  return (
    <>
      <PackingSlip returnId={returnId} orderDetails={orderDetails} />
      <RmaDetailLRPrintSlip
        type="button"
        onClick={printClick}
      >
        Print Packing Slip
      </RmaDetailLRPrintSlip>
    </>
  )
}

export default ConfirmationButton
